module.exports = __webpack_public_path__ + "static/media/NextStepEmailOpen.406f20f0.svg";